export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6413.e1bf2d80.jpg";